import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteJournalEntryFooter', {
    debitTitle: 'Debit',
    creditTitle: 'Credit',
    totalTitle: 'Total',
    subtotalTitle: 'Subtotal',
    totalTaxTitle: 'Total Tax',
    totalIsOutBy: 'Total is out by:',
});
